<template>

  <!-- Modal component -->
  <modal :show.sync="showModal" >
    <delete-user :user.sync="userToDelete" ></delete-user>
  </modal>

  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <breadcrumb></breadcrumb>
        <h1>Utilisateurs</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/administration/add'}">Ajouter un nouvel utilisateur</a>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <td colspan="6" class="text-xs-right">{{ usersList.length }} utilisateurs enregistrés</td>
        </tr>
        <tr>
          <th @click.prevent="sort('username')">Nom d'utilisateur <span :class="usernameClass"></span></th>
          <th @click.prevent="sort('firstname')">Nom complet <span :class="nameClass"></span></th>
          <th>Adresse email</th>
          <th>Couleur</th>
          <th>Téléphone</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user of usersList | orderBy orderType orderAsc">
          <td>{{ user.username }}</td>
          <td>{{ user.firstname }} {{ user.lastname }}</td>
          <td>{{ user.email }}</td>
          <td><span class="tag-color" :style="{background: user.color}"></span></td>
          <td>{{ user.phone }}</td>
          <td>
            <button class="btn btn-primary" v-link="{ name: 'editUser', params: { userId: user.id }}">Editer</button>
            <button class="btn btn-warning" @click="modalDelete(user)">Supprimer</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/administration/add'}">Ajouter un nouvel utilisateur</a>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import Modal from '../modals/Modal.vue'
import DeleteUser from '../modals/DeleteUser.vue'
import Breadcrumb from '../nav/Breadcrumb.vue'

// Vuex specifics
import { users } from '../../vuex/getters'
import { getUsers } from '../../vuex/actions/userActions'

export default{
  vuex: {
    getters: { users },
    actions: { getUsers }
  },
  data () {
    return {
      orderType: 'username',
      orderAsc: 1,
      showModal: false,
      userToDelete: null
    }
  },
  computed: {
    usersList () {
      return this.users
    },
    usernameClass () { return this.getClass('username') },
    nameClass () { return this.getClass('firstname') }
  },
  methods: {
    getClass (property) {
      if (this.orderType === property) {
        if (this.orderAsc === -1) {
          return 'icon-sort-asc'
        }
        return 'icon-sort-desc'
      }
      return 'icon-unsorted'
    },
    sort (filter) {
      if (this.orderType === filter) {
        this.orderAsc = this.orderAsc * -1
      } else {
        this.orderType = filter
      }
    },
    modalDelete (user) {
      this.userToDelete = user
      this.showModal = true
    }
  },
  components: {
    Modal,
    DeleteUser,
    Breadcrumb
  },
  events: {
    'deleteUser': function () {
      if (this.userToDelete) {
        this.deleteUser(this.userToDelete)
        this.userToDelete = null
      }
    }
  },
  ready () {
    this.getUsers()
  }
}
</script>



// WEBPACK FOOTER //
// UsersList.vue?5ab8bc54